import { Controller } from "@hotwired/stimulus"

// « Règles de caisse » (cash desk overhaul, lot 1). A step switched off hides
// its settings; the remittance cannot stay on without the counting; a starting
// point switches the three steps at once; the « Parcours qui en résulte »
// panel follows. For one desk, a step it does not set itself is greyed: it
// follows the school.
export default class extends Controller {
  static targets = ["step", "stepBody", "preset", "journey", "count", "own", "card", "remittanceNeedsCounting",
                    "reminderMode", "reminderSetting"]
  static values = { presets: Object, countText: String, editable: Boolean }

  connect() {
    this.sync()
  }

  applyPreset(event) {
    if (!this.editableValue) return
    const steps = this.presetsValue[event.currentTarget.dataset.preset]
    if (!steps) return

    this.stepTargets.forEach((toggle) => {
      const value = steps[`${toggle.dataset.step}_enabled`]
      if (value === undefined) return
      // On one desk, the starting point makes the three steps its own.
      const own = this.ownTargets.find((box) => box.value === toggle.dataset.step)
      if (own && !own.checked) { own.checked = true }
      toggle.checked = value
    })
    this.sync()
  }

  sync() {
    const counting = this.enabled("counting")
    const remittance = this.stepTargets.find((toggle) => toggle.dataset.step === "remittance")
    if (remittance) {
      if (!counting) remittance.checked = false
      if (this.editableValue) remittance.disabled = !counting || this.followed("remittance")
    }
    this.remittanceNeedsCountingTargets.forEach((hint) => { hint.hidden = counting })

    // A step's settings when it is on, a line saying what the system does when it is off.
    this.stepBodyTargets.forEach((body) => {
      const on = this.enabled(body.dataset.step)
      body.hidden = body.hasAttribute("data-when-off") ? on : !on
    })
    this.cardTargets.forEach((card) => {
      const followed = this.followed(card.dataset.card)
      if (this.editableValue) card.disabled = followed
      card.classList.toggle("opacity-60", followed)
    })
    this.stepTargets.forEach((toggle) => {
      if (this.editableValue && toggle.dataset.step !== "remittance") toggle.disabled = this.followed(toggle.dataset.step)
    })

    // Reminded at an hour of the day, or every N hours: only the field that applies.
    if (this.hasReminderModeTarget) {
      this.reminderSettingTargets.forEach((field) => { field.hidden = field.dataset.mode !== this.reminderModeTarget.value })
    }

    let manual = 0
    this.journeyTargets.forEach((item) => {
      const on = item.dataset.step ? this.enabled(item.dataset.step) : true
      item.querySelectorAll("[data-when]").forEach((part) => { part.hidden = (part.dataset.when === "on") !== on })
      if (item.dataset.manual === "true" && on) manual += 1
    })
    if (this.hasCountTarget) this.countTarget.textContent = this.countTextValue.replace("%{count}", manual)

    const current = JSON.stringify(this.currentSteps())
    this.presetTargets.forEach((button) => {
      const active = JSON.stringify(this.presetsValue[button.dataset.preset]) === current
      button.setAttribute("aria-pressed", active ? "true" : "false")
    })
  }

  enabled(step) {
    const toggle = this.stepTargets.find((target) => target.dataset.step === step)
    if (!toggle) return true
    if (step === "remittance" && !this.enabled("counting")) return false
    return toggle.checked
  }

  // A step of one desk left to the school (no own box: the school's page).
  followed(card) {
    const own = this.ownTargets.find((box) => box.value === card)
    return own ? !own.checked : false
  }

  currentSteps() {
    return {
      counting_enabled: this.enabled("counting"),
      remittance_enabled: this.enabled("remittance"),
      validation_enabled: this.enabled("validation"),
    }
  }
}
